export const routes = {
  root: "/",
  admin: "admin",
  bomUser: "bom-user",
  login: "login",
  changePassword: "change-password",
  forgotPassword: "forgot-password",
  resetPasswordOtp: "reset-password-otp",
  termsCondition: "terms-condition",
  downloadFile:"download-file",
  dashboard: "dashboard",
  myProfile: "my-profile",
  myNeighbors: "my-neighbors",
  communities: "communities",
  adminConsole: "admin-console",
  details: "details",
  add: "add",
  edit: "edit",
  view: "view",
  id: ":id",
  zoneId: ":zoneId",
  propertyId: ":propertyId",
  userId: ":userId",
  properties: "properties",
  users: "users",
  action: ":action",
  status: ":status",
  clearingId: ":clearingId",
  masterData: "master-data",
  glSetup: "gl-setup",
  financialStatementVersions: "financial-statement-versions",
  propertyMgmt: "property-mgmt",
  propertyCategory: "property-category",
  propertyModel: "property-model",
  propertyBlock: "property-block",
  propertyZone: "property-zone",
  insuranceType: "insurance-type",
  paymentMethod: "payment-method",
  paymentTerm: "payment-term",
  billingCategory: "billing-category",
  incidentType: "incident-type",
  incidentCategory: "incident-category",
  tncVariable: "tnc-variable",
  stateLaw: "state-law",
  manageBOM: "manage-bom",
  budgetMgmt: "budget-mgmt",
  budgetId: ":budgetId",
  simulate: "simulate",
  lineItems: "line-items",
  lineItemId: ":lineItemId",
  approvals: "approvals",
  budgetApprovals: "budget-approvals",
  owner: "owner",
  bom: "bom",
  propertyOwnership: "property-ownership",
  createOwner: "create",
  newOwnership: "new",
  ownerReport: "owner-report",
  userManagement: "user-management",
  propertyReport: "property-report",
  documentTypeConfig: "document-type-config",
  documentTypeId: ":documentTypeId",
  vendorMgmt: "vendors",
  vendorId: ":vendorId",
  activityDashboard: "activity-dashboard",
  invoice: "invoice",
  listing: "listing",
  invoiceId: ":invoiceId",
  invoiceAction: ":invoiceAction",
  payment: "payment",
  paymentId: ":paymentId",
  paymentAction: ":paymentAction",
  tolerance: "tolerance",
  finance: "finance",
  billing: "billing",
  billingHistory: "billing-history",
  transactionHistory: "transaction-history",
  billingConfig: "billing-config",
  billingId: ":billingId",
  billingAction: ":billingAction",
  pendingPosting: "pending-posting",
  billedForPeriod: "billed-for-period",
  billingLog: "billing-log",
  journalEntry: "journal-entry",
  employee: "employee",
  accessMgmt: "access-mgmt",
  reports: "reports",
  invoiceReports: "invoice-reports",
  cam: "cam",
  glId: ":glId",
  month: ":month",
  incident: "incident",
  clearing: "clearing",
  generalLedger: "general-ledger",
  cashApp: "cash-app",
  paymentReport: "payment-report",
  collection: "collection",
  ar360: "ar-360",
  incidentMgmt: "incident-mgmt",
  templates: "templates",
  customTemplate: 'custom-template',
  predefinedTemplate: 'predefined-template',
  stateLevelTnc: 'state-level-tnc',
  helpDocument: 'help-document',
  fiscalYearClosing: 'fiscal-year-closing',
  fiscalYearLifeCycle: 'fiscal-year-life-cycle',
  report: "report",
  glReports: "gl-reports",
  trialBalance: "trial-balance",
  costTrialBalance: "cost-trial-balance",
  managerialReport: "managerial-report",
  copyDistributionConfiguration: "copy-distribution-configuration",
  vendorTrialBalance: "vendor-trial-balance",
  ownerTrialBalance: "owner-trial-balance",
  displayAccountingDocument: "display-accounting-document",
  glConfigurationStudio: "gl-configuration-studio",
  createJEManual: "create-je-manual",
  jeManual: "je-manual",
  auditTrail: "audit-trail",
  distributionRuleConfiguration: "distribution-rule-configuration",
  distributionMetricsMaintenance: "distribution-metrics-maintenance",
  distributionRuntimeDetails: "distribution-run-time-details",
  bulkUpload: "bulk-upload",
  uploadHistory: "upload-history",
  attachmentId: ":attachmentId",
  traceability: "traceability-report",
  fixedWeight: "fixed-weight",
  weighingFactor: "weighing-factor",
  level: ":level",
  type: ":type",
  reconciliation: "reconciliation-report",
  closeout: "closeout-report",
  reportByOwner: "report-by-owner",
  reportByVendor: "report-by-vendor",
  virtualAcc: "virtual-acc",
  audit: "audit",
  announcement: "announcement",
  costAnalytics: "cost-analytics",
  balanceReport: "balance-report",
  ownerChangePackage: "owner-change-package",
  ocpFeeTypes: "ocp-fee-types",
  ocpDocTypes: "ocp-doc-types"
};

export const getOwnerBomBase = (pathname?: string) =>
  pathname?.startsWith(`/${routes.bom}`) ? routes.bom : routes.owner;
